import React, { useState, useContext, useEffect, Fragment } from 'react'
import './EventModal.css'

import moment from 'moment'
import Axios from 'axios'

import {
	Modal,
	ModalHeader,
	ModalBody,
	Container,
	Row,
	Col,
	Form,
	Label,
	Input,
	Button,
	Alert,
} from 'reactstrap'
import Select from '../select/Select.js'
import { SPContext } from '../../SPContext'
import ConfirmDialogModal from '../confirm_dialog/ConfirmDialogModal'

const close_button = React.createRef()

const EventModalEdit = React.memo(({ className, header, body, footer }) => {
	const {
		user_id,
		users,
		token,
		uri,
		event,
		events,
		setEvents,
		isOpen,
		handleOpenEventModal,
		event_types,
		categories,
		event_status,
		locations,
		isAdmin,
	} = useContext(SPContext)

	const [didMount, setDidMount] = useState(false)
	const [lc_event, setLcEvent] = useState({
		id: '',
        event_id: 0,
        event_FK_event_status_id: 4,
        event_FK_event_price_type_id: -1,
        event_featured_flag: false,
        event_title: '',
        event_FK_event_summary_id: 0,
        event_FK_event_description_id: 0,
        event_date_start: '',
        event_response_deadline: '',
        event_needed_min: 0,
        event_needed_max: '',
        event_FK_location_id: -1,
        event_map_link: '',

        event_holiday_required: false,
        event_holiday_work_days: '',

        event_family_welcome: false,
        event_age_limit: -1,
        event_friends_welcome: false,

        event_company_contribution_per_person: 0,
		event_company_contribution: '',
        event_cost_individual: 0,
        event_related_website: '',

        event_description_value: '',
		event_summary_value: '',
		
		event_status_label: '',
		going_length: '',
		likes_length: '',
    })

	const [open_confirm_dialog, setOpenConfirmDialog] = useState(false)
	const [open_confirmed_dialog, setOpenConfirmedDialog] = useState(false)
	// const [open_featured_dialog, setOpenFeaturedDialog] = useState(false)

	const [confirm_dialog_event_id, setConfirmDialogEventId] = useState(0)
	const [confirm_dialog_title, setConfirmDialogTitle] = useState(false)
	const [confirm_dialog_content, setConfirmDialogContent] = useState(false)
	// const [confirm_dialog_function, setConfirmDialogFunction] = useState({})

	const [is_alert_open, setIsAlertOpen] = useState(false)
	const [alert_message, setAlertMessage] = useState()
	const [alert_color, setAlertColor] = useState('info')

	const [is_processing, setIsProcessing] = useState(false)
	const [is_waiting_save, setIsWaitingSave] = useState(false)
	const [is_waiting_submit, setIsWaitingSubmit] = useState(false)

	const toggleAlert = () => {
		setIsAlertOpen(!is_alert_open)
	}

	const holiday_required = [
		{
			id: 0,
			label: '0',
			value: '0',
		},
		{
			id: 1,
			label: '1',
			value: '1',
		},
		{
			id: 2,
			label: '2',
			value: '2',
		},
		{
			id: 3,
			label: '3',
			value: '3',
		},
		{
			id: 4,
			label: '4',
			value: '4',
		},
		{
			id: 5,
			label: '5',
			value: '5',
		},
		{
			id: 6,
			label: '6',
			value: '6',
		},
		{
			id: 7,
			label: '7',
			value: '7',
		},
		{
			id: 8,
			label: '8',
			value: '8',
		},
		{
			id: 9,
			label: '9',
			value: '9',
		},
		{
			id: 10,
			label: '10',
			value: '10',
		},
	]

	const age_limit = [
		{
			id: 1,
			label: 'No limit',
			value: 1,
		},
		{
			id: 2,
			label: 'Over 18',
			value: 2,
		},
		{
			id: 3,
			label: 'Over 21',
			value: 3,
		},
	]

	const event_status_select = event_status.reduce((new_layout, status) => {
		new_layout.push({
			id: status.event_status_id,
			label: status.event_status_label,
			value: status.event_status_id,
		})
		return new_layout
	}, [])

	useEffect(() => {
		if (!didMount && isOpen) {
			const going_length = event.going ? event.going.length : 0
			const likes_length = event.likes ? event.likes.length : 0

			const event_date_start = moment(event.event_date_start).format(
				'YYYY-MM-DD',
			)
			const event_date_end = moment(event.event_date_end).format('YYYY-MM-DD')
			const event_response_deadline = moment(
				event.event_response_deadline,
			).format('YYYY-MM-DD')

			const the_event = {
				...event,
				event_date_start,
				event_date_end,
				event_response_deadline,
				going_length,
				likes_length,
			}

			setLcEvent(the_event)

			setTmpSelectedFile(
				event.event_id === 0 ? '/images/default_image.jpg' : event.main_image,
			)

			setTmpSelectedFeaturedFile(
				event.event_id === 0
					? '/images/default_image.jpg'
					: event.event_featured_image
					? event.event_featured_image
					: '/images/default_image.jpg',
			)

			setDidMount(true)
		}

		if (
			lc_event &&
			isAdmin &&
			parseInt(lc_event.event_FK_event_status_id, 10) !== 4
		) {
			setToApprove(true)
		} else {
			setToApprove(false)
		}

		let new_event = { ...lc_event }

		formValid(new_event)
	})

	const event_status_default =
		(event &&
			event_status_select &&
			event_status_select.find(
				status =>
					parseInt(status.id, 10) ===
					parseInt(event.event_FK_event_status_id, 10),
			)) ||
		[]

	const categories_default =
		(event &&
			event.categories &&
			categories.reduce((selected, category, index) => {
				!!event.categories.find(
					event_category =>
						parseInt(event_category.category_id, 10) ===
						parseInt(category.id, 10),
				) && selected.push(categories[index])
				return selected
			}, [])) ||
		[]

	const price_type_default =
		(event &&
			event_types.find(
				event_type =>
					parseInt(event_type.id, 10) ===
					parseInt(event.event_FK_event_price_type_id, 10),
			)) ||
		[]

	const location_default =
		(event &&
			locations.find(
				event_location =>
					parseInt(event_location.id, 10) ===
					parseInt(event.event_FK_location_id, 10),
			)) ||
		[]

	const age_limit_default =
		(event &&
			age_limit.find(
				age_limit_item =>
					parseInt(age_limit_item.id, 10) ===
					parseInt(event.event_age_limit, 10),
			)) ||
		[]

	const holiday_required_default =
		(event &&
			holiday_required.find(
				holiday_required_item =>
					parseInt(holiday_required_item.id, 10) ===
					parseInt(event.event_holiday_work_days, 10),
			)) ||
		[]

	const onChangeField = target => {
		const value =
			target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value
		setLcEvent({ ...lc_event, [target.name]: value })
	}

	const onChangeEventStatus = (value, action) => {
		const new_event = {
			...lc_event,
			event_FK_event_status_id: parseInt(value.id, 10),
		}

		setLcEvent(new_event)
	}

	const onChangeType = (value, action) => {
		const new_event = {
			...lc_event,
			event_FK_event_price_type_id: parseInt(value.id, 10),
		}

		setLcEvent(new_event)
	}

	const onChangeCategory = (value, action) => {
		const new_event = { ...lc_event, categories: value }
		setLcEvent(new_event)
	}

	const onChangeHoliday = (value, action) => {
		const event_holiday_required = value === 0 ? 0 : 1
		const new_event = {
			...lc_event,
			event_holiday_required,
			event_holiday_work_days: value.value,
		}
		setLcEvent(new_event)
	}

	const onChangeAgeLimit = (value, action) => {
		const new_event = {
			...lc_event,
			event_age_limit: value,
		}
		setLcEvent(new_event)
	}

	const onChangeLocation = (value, action) => {
		const new_event = {
			...lc_event,
			event_FK_location_id: parseInt(value.id, 10),
		}
		setLcEvent(new_event)
	}

	// Validate File Extension
	const validateImageExt = (file, image_title) => {
		const validTypes = ["gif", "jpeg", "jpg", "png", "GIF", "JPEG", "JPG", "PNG"];
		const fileExtension = file.name.split('.').pop().toLowerCase()
		if (!validTypes.includes(fileExtension)) {
			setAlertColor('warning');
			setAlertMessage(`Invalid file extension ( .${fileExtension} ) of ${image_title}. Please select a valid image.`);
			setIsAlertOpen(true);
			setIsWaitingSave(false)
			setIsProcessing(false)
			setSaveButtonDisabled(true)
			return false;
		}
		return true;
	};

	const closeButton = (
		<Button
			ref={close_button}
			color='secondary'
			onClick={e => lc_handleOpenEventModal(e, lc_event.id)}
		>
			close
		</Button>
	)

	const lc_handleOpenEventModal = (e, lc_event_id) => {
		setIsAlertOpen(false)
		setDidMount(false)
		setSelectedFile(null)
		handleOpenEventModal(e, 'edit', lc_event_id)
	}

	const [to_approve, setToApprove] = useState(false)
	const [to_submit, setToSubmit] = useState(false)
	const [to_delete, setToDelete] = useState(false)

	const [save_button_disabled, setSaveButtonDisabled] = useState(false)

	const saveEvent = (e, action) => {
		setIsWaitingSave(false)
		setIsWaitingSubmit(false)

		switch (action) {
			case 'save':
				setToSubmit(false)
				setToApprove(false)
				setIsWaitingSave(true)
				break

			case 'submit':
				setToSubmit(true)
				setIsWaitingSubmit(true)
				break

			case 'delete':
				setToDelete(true)
				break

			default:
				setToSubmit(false)
				setToApprove(false)
				setToDelete(false)
				break
		}
	}

	const postEvent = event => {
		setIsProcessing(true)
		setIsAlertOpen(false)

		let t_event = event

		if (!event) {
			t_event = { ...lc_event }
		}

		if (to_submit) {
			setAlertMessage('Event submitted')
			t_event.event_FK_event_status_id = 1
		} else if (
			to_approve &&
			parseInt(t_event.event_FK_event_status_id, 10) === 1
		) {
			setAlertMessage('Event approved')
			t_event.event_FK_event_status_id = 2
		} else if (to_delete) {
			t_event.event_FK_event_status_id = -1
		} else {
			setAlertMessage('Event saved')
			if (!isAdmin) {
				t_event.event_FK_event_status_id = 4
			}
		}

		let data = new FormData()
		data.append('token', token)

		for (let key in t_event) {
			if (typeof t_event[key] !== 'object') {
				data.append(key, t_event[key])
			} else {
				data.append(key, JSON.stringify(t_event[key]))
			}
		}

		if (selectedFile && selectedFile.name) {
			if (!validateImageExt(selectedFile , "Thumbnail image"))
				return false;
			data.append('image', selectedFile, selectedFile.name)
		}

		if (selectedFeaturedFile && selectedFeaturedFile.name) {
			if (!validateImageExt(selectedFeaturedFile, "Featured image"))
				return false;
			data.append(
				'featured_image',
				selectedFeaturedFile,
				selectedFeaturedFile.name,
			)
		}

		data.append('token', token)

		Axios.post(`${uri}Event/save`, data)
			.then(response => {
				const data = response.data

				setSaveButtonDisabled(true)

				let axios_events = events.filter(
					event_item =>
						parseInt(event_item.event_id, 10) !== parseInt(data.event_id, 10),
				)

				let axios_event = data.data[data.event_id]
				axios_event.event_date_start = moment(
					axios_event.event_date_start,
				).format('YYYY-MM-DD')

				axios_event.event_date_end = moment(axios_event.event_date_end).format(
					'YYYY-MM-DD',
				)

				axios_event.event_response_deadline = moment(
					axios_event.event_response_deadline,
				).format('YYYY-MM-DD')

				axios_events = [...axios_events, axios_event]

				setEvents(axios_events)
				setLcEvent({...axios_event, 
				
					going_length:t_event.going_length,
					likes_length:t_event.likes_length,
			
				})

				setToSubmit(false)

				if (isAdmin && axios_event.event_FK_event_status_id !== 4) {
					setToApprove(true)
				} else {
					setToApprove(false)
				}

				// setAlertMessage('Event saved')
				setAlertColor('success')
				setIsAlertOpen(true)

				setIsWaitingSave(false)
				setIsWaitingSubmit(false)

				setIsProcessing(false)
			})
			.catch(err => {
				setIsProcessing(false)
				setIsWaitingSave(false)
				setIsWaitingSubmit(false)
				console.log(err)
			})
	}

	// const confirmFeatured = (e, confirmed) => {
	//   setOpenFeaturedDialog(false)

	//   let t_event = { ...lc_event }

	//   if (confirmed) {
	//     t_event.event_featured_flag = true
	//   }
	//   postEvent(t_event)
	// }

	// const askFeatured = (e, event_id) => {
	//   setConfirmDialogTitle('Featured event?')
	//   setConfirmDialogContent(() => (
	//     <div>
	//       <span>Do you want to featured this event?</span>
	//       <p />
	//       <p>
	//         <strong>{lc_event.event_title}</strong>
	//       </p>
	//     </div>
	//   ))
	//   // setConfirmDialogEventId(event_id)
	//   setOpenFeaturedDialog(true)
	// }

	const onSubmitEventForm = e => {
		e.preventDefault()

		if (
			lc_event.event_FK_event_status_id !== 5 && 
			moment(lc_event.event_date_start).format('YYYYMMDD') <
			moment(new Date()).format('YYYYMMDD')
		) {
			alert('"Start date" is incorrect. Must be greater than the current date.')
			return false
		}

		lc_event.event_featured_flag = lc_event.event_featured_flag === true || lc_event.event_featured_flag === 1 ? 1 : 0
		lc_event.event_family_welcome = lc_event.event_family_welcome === true || lc_event.event_family_welcome === 1 ? 1 : 0
		lc_event.event_friends_welcome = lc_event.event_friends_welcome === true || lc_event.event_friends_welcome === 1 ? 1 : 0

		// if (to_approve && lc_event.event_featured_flag === false) {
		//   askFeatured()
		// } else {
		postEvent({ ...lc_event })
		// }
	}

	const confirmDelete = (e, confirmed) => {
		setIsProcessing(true)
		if (confirmed) {
			const event_id = confirm_dialog_event_id

			let data = new FormData()
			data.append('event_id', event_id)
			data.append('event_FK_event_status_id', -1)
			data.append('token', token)

			Axios.post(`${uri}Event/save`, data)
				.then(response => {
					let axios_events = events.filter(
						event_item =>
							parseInt(event_item.event_id, 10) !== parseInt(event_id, 10),
					)
					setEvents(axios_events)
					setOpenConfirmDialog(false)
					eventDeleted()

					setIsProcessing(false)
				})
				.catch(err => {
					console.log(err)
				})
		} else {
			setIsProcessing(false)
			setOpenConfirmDialog(false)
		}
	}

	const deleteEvent = (e, event_id) => {
		setConfirmDialogTitle('Remove event')
		setConfirmDialogContent(() => (
			<div>
				<span>Are you sure you want to remove this event?</span>
				<p />
				<p>
					<strong>{lc_event.event_title}</strong>
				</p>
			</div>
		))
		setConfirmDialogEventId(event_id)
		setOpenConfirmDialog(true)
	}

	const deletedSuccessfully = () => {
		setOpenConfirmedDialog(false)
		close_button.current.onClick()
	}

	const eventDeleted = () => {
		setConfirmDialogTitle('Event removed')
		setConfirmDialogContent(() => (
			<div>
				<span>Event was removed!</span>
				<p />
				<p>
					<strong>{lc_event.event_title}</strong>
				</p>
			</div>
		))
		setOpenConfirmedDialog(true)
	}

	const [form_valid, setFormValid] = useState(false)

	const formValid = current_event => {
		if (
			!current_event.categories ||
			current_event.categories.length <= 0 ||
			current_event.event_FK_location_id < 0 ||
			current_event.event_age_limit < 0 ||
			tmpSelectedFile === null ||
			tmpSelectedFile === '/images/default_image.jpg'
		) {
			setFormValid(false)
		} else {
			setFormValid(true)
			setSaveButtonDisabled(false)
		}
	}

	const getUser = lc_user_id => {
		if (lc_user_id === undefined) {
			lc_user_id = user_id
		}
		const user = users && users.find(u => u.id === lc_user_id)
		return (
			(user && {
				...user,
				label: user.first_name + ' ' + user.last_name,
			}) ||
			{}
		)
	}

	const staff_image_default =
		'https://socialfiles.blob.core.windows.net/staff/staff.png'
	const staffImageError = e => {
		e.target.src = staff_image_default
	}

	const [selectedFile, setSelectedFile] = useState({})
	const [tmpSelectedFile, setTmpSelectedFile] = useState(null)

	const fileSelect = event => {
		setSelectedFile(event.target.files[0])
		setTmpSelectedFile(URL.createObjectURL(event.target.files[0]))
	}

	const [selectedFeaturedFile, setSelectedFeaturedFile] = useState({})
	const [tmpSelectedFeaturedFile, setTmpSelectedFeaturedFile] = useState(null)

	const featuredFileSelect = event => {
		setSelectedFeaturedFile(event.target.files[0])
		setTmpSelectedFeaturedFile(URL.createObjectURL(event.target.files[0]))
	}

	const event_status_list = [2, 5]
	const acceptable_event_status = event_status_list.find(
		a => a === parseInt(lc_event.event_FK_event_status_id, 10),
	)

	const save_is_disabled = acceptable_event_status && !isAdmin

	const submit_is_disabled =
		acceptable_event_status ||
		(to_submit && parseInt(lc_event.event_FK_event_status_id, 10) === 1) ||
		(parseInt(lc_event.event_FK_event_status_id, 10) === 1 && !isAdmin)

	return (
		<>
			<Modal
				size='xl'
				// size='md'
				backdrop={'static'}
				isOpen={isOpen}
				className={
					(className === undefined ? '' : className) +
					' modal-dialog-scrollable modal-dialog-centered sp-event-modal'
				}
			>
				<ModalHeader
					toggle={handleOpenEventModal}
					close={closeButton}
					className='sp-event-modal-header'
				>
					<span className='sp-event-modal-header-logo'>
						<img
							className='white'
							src='/images/play-plan-black.png'
							alt='plan.com'
						/>
					</span>
				</ModalHeader>

				<ModalBody className='sp-event-modal-body'>
					{false && (
						<Container>
							<Row>
								<Col className='text-center'>
									This feature
									<br />
									is coming soon!
								</Col>
							</Row>
						</Container>
					)}

					{true && (
						<Container>
							<Form id='sp-event-modal-form-edit' onSubmit={onSubmitEventForm}>
								<Row>
									<Col xs={{ size: 12, order: 2 }} lg={{ size: 8 }}>
										<Row>
											<Col className='sp-event-modal-field-bottom'>
												<Label htmlFor='event_modal_title'>Event title</Label>
												<Input
													type='text'
													id='event_modal_title'
													placeholder=''
													value={lc_event.event_title}
													name='event_title'
													onChange={e => onChangeField(e.target)}
													required={true}
												/>
											</Col>
										</Row>

										<Row>
											<Col className='sp-event-modal-field-bottom'>
												<Label htmlFor='event_modal_event_summary_value'>
													Summary
												</Label>
												<Input
													type='textarea'
													rows='2'
													id='event_modal_event_summary_value'
													value={lc_event.event_summary_value}
													name='event_summary_value'
													onChange={e => onChangeField(e.target)}
													required={true}
												/>
											</Col>
										</Row>

										<Row>
											<Col className='sp-event-modal-field-bottom'>
												<Label htmlFor='event_modal_event_description_value'>
													Description
												</Label>
												<Input
													type='textarea'
													rows='3'
													id='event_modal_event_description_value'
													value={lc_event.event_description_value}
													name='event_description_value'
													onChange={e => onChangeField(e.target)}
													required={false}
												/>
											</Col>
										</Row>

										<Row>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_type'>Event type</Label>
												<Fragment>
													<Select
														id='event_modal_event_type'
														value='null'
														defaultValue={price_type_default}
														placeholder='SELECT'
														options={event_types}
														isMulti={false}
														onChange={onChangeType}
														required={true}
													/>
												</Fragment>
											</Col>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_event_tickets_cost'>
													Total cost per person
												</Label>

												<Input
													type='number'
													step='.01'
													id='event_modal_event_tickets_cost'
													value={lc_event.event_cost_individual}
													name='event_cost_individual'
													onChange={e => onChangeField(e.target)}
													min={0}
													// required={lc_event.event_cost_individual}
												/>
											</Col>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_event_tickets_cost'>
													plan.com contribution
												</Label>

												<Input
													type='number'
													step='.01'
													id='event_modal_event_tickets_cost'
													value={lc_event.event_company_contribution_per_person}
													name='event_company_contribution_per_person'
													onChange={e => onChangeField(e.target)}
													// disabled={!event.event_company_contribution}
													min={0}
													// required={lc_event.event_company_contribution}
												/>
											</Col>
										</Row>
										<Row>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_location'>Location</Label>
												<Select
													id='event_modal_location'
													placeholder='SELECT'
													options={locations}
													defaultValue={location_default}
													isMulti={false}
													onChange={onChangeLocation}
												/>
											</Col>
											<Col
												xl={{ size: 8 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_event_map_link'>
													Google Map link (Embed a map)
												</Label>
												<Input
													type='text'
													id='event_modal_event_map_link'
													placeholder=''
													value={lc_event.event_map_link}
													name='event_map_link'
													onChange={e => onChangeField(e.target)}
													// required={true}
												/>
											</Col>
										</Row>
										<Row>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_event_date_start'>
													Date Start
												</Label>
												<Input
													type='date'
													id='event_modal_event_date_start'
													value={lc_event.event_date_start}
													name='event_date_start'
													onChange={e => onChangeField(e.target)}
													required={true}
												/>
											</Col>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_event_response_deadline'>
													Book by date
												</Label>
												<Input
													type='date'
													id='event_modal_event_response_deadline'
													value={lc_event.event_response_deadline}
													name='event_response_deadline'
													onChange={e => onChangeField(e.target)}
													required={true}
												/>
											</Col>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_event_holiday'>
													Personal holiday required?
												</Label>
												<Select
													id='event_modal_holiday'
													value='null'
													options={holiday_required}
													defaultValue={holiday_required_default}
													isMulti={false}
													onChange={onChangeHoliday}
													required={true}
												/>
											</Col>{' '}
										</Row>
										<Row>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Row>
													<Col>
														<Label htmlFor='event_modal_travel_requirement'>
															Kid friendly?
														</Label>
													</Col>
												</Row>
												<Row>
													<Col>
														<Input
															type='checkbox'
															id='event_modal_family_welcome'
															checked={lc_event.event_family_welcome}
															name='event_family_welcome'
															onChange={e => onChangeField(e.target)}
															className='sp-event-modal-input-checkbox'
														/>
													</Col>
												</Row>
											</Col>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Row>
													<Col>
														<Label htmlFor='event_modal_travel_requirement'>
															Friends welcome?
														</Label>
													</Col>
												</Row>
												<Row>
													<Col>
														<Input
															type='checkbox'
															id='event_modal_friends_welcome'
															checked={lc_event.event_friends_welcome}
															name='event_friends_welcome'
															onChange={e => onChangeField(e.target)}
															className='sp-event-modal-input-checkbox'
														/>
													</Col>
												</Row>
											</Col>
											<Col
												xl={{ size: 4 }}
												className='sp-event-modal-field-bottom'
											>
												<Label htmlFor='event_modal_event_age_limit'>
													Age limit
												</Label>
												<Select
													id='event_modal_age_limit'
													value='null'
													options={age_limit}
													defaultValue={age_limit_default}
													isMulti={false}
													onChange={onChangeAgeLimit}
													required={true}
												/>
											</Col>{' '}
										</Row>
										<Row>
											<Col className='sp-event-modal-field-bottom'>
												<Label htmlFor='event_modal_category'>
													Event category(s)
												</Label>
												<Select
													id='event_modal_category'
													value='null'
													options={categories}
													defaultValue={categories_default}
													isMulti={true}
													onChange={onChangeCategory}
													required={true}
												/>
											</Col>
										</Row>
										<Row>
											<Col className='sp-event-modal-field-bottom'>
												<Label htmlFor='event_modal_event_related_website'>
													Related website <span>(optional)</span>
												</Label>
												<Input
													type='text'
													id='event_modal_event_related_website'
													placeholder=''
													value={lc_event.event_related_website}
													name='event_related_website'
													onChange={e => onChangeField(e.target)}
												/>
											</Col>
										</Row>
									</Col>

									<Col
										xs={{ size: 12 }}
										lg={{ size: 4, order: 2 }}
										className='mb-2'
									>
										<Row>
											<Col xs='2'>
												<div className='sp-event-view-user-image'>
													<img
														width={50}
														height={50}
														src={
															'/timthumb.php?width=50&height=50&src=https://socialfiles.blob.core.windows.net/staff/' +
															(event.event_FK_created_by_user_id || user_id) +
															'.jpg?token=' +
															token
														}
														onError={staffImageError}
														alt=''
													/>
												</div>
											</Col>
											<Col>
												<Row className='mt-2'>
													<Col className='organiser'>Event organiser</Col>
												</Row>
												<Row>
													<Col>
														<strong>
															<h5>
																{
																	getUser(event.event_FK_created_by_user_id)
																		.label
																}
															</h5>
														</strong>
													</Col>
												</Row>
											</Col>
										</Row>
										<Row>
											<Col
												xs='4'
												className={
													'sp-event-modal-field-bottom' +
													(isAdmin ? ' sp-event-modal-event-status' : '')
												}
											>
												Event status:
											</Col>
											<Col xs='8' className='sp-event-modal-field-bottom'>
												{!isAdmin ? (
													<span>{lc_event.event_status_label}</span>
												) : (
													<>
														<Select
															id='event_modal_event_status'
															value='null'
															defaultValue={event_status_default}
															placeholder='SELECT'
															options={event_status_select}
															isMulti={false}
															onChange={onChangeEventStatus}
															required={true}
														/>
													</>
												)}
											</Col>
										</Row>
										<Row>
											<Col className='sp-event-modal-field-bottom'>
												<Button
													type='submit'
													onClick={e => saveEvent(e, 'save')}
													color='success'
													disabled={
														!form_valid ||
														save_is_disabled ||
														save_button_disabled ||
														is_processing
													}
													block
												>
													Save{' '}
													{is_waiting_save ? (
														<i className='fas fa-sync-alt fa-spin' />
													) : null}
												</Button>
											</Col>
										</Row>
										{!isAdmin ? (
											<Row>
												<Col className='sp-event-modal-field-bottom'>
													<Button
														type='submit'
														onClick={e =>
															saveEvent(e, to_approve ? 'approve' : 'submit')
														}
														color='primary'
														disabled={
															!form_valid || submit_is_disabled || is_processing
														}
														block
													>
														{to_approve ? 'Approve (Publish)' : 'Submit'}{' '}
														{is_waiting_submit ? (
															<i className='fas fa-sync-alt fa-spin' />
														) : null}
													</Button>
												</Col>
											</Row>
										) : null}
										<Row>
											<Col className='sp-event-modal-field-bottom'>
												<Button
													color='danger'
													onClick={e => deleteEvent(e, lc_event.event_id)}
													disabled={lc_event.event_id === 0 || is_processing}
													block
												>
													Delete
												</Button>
											</Col>
										</Row>
										<Row>
											<Col className='sp-event-modal-field-bottom sp-event-modal-img text-center'>
												<img
													src={tmpSelectedFile}
													alt='required'
													className='img-fluid'
												/>
												<label
													className={
														'sp-event-file-container btn btn-secondary' +
														(is_processing ||
														parseInt(lc_event.event_FK_event_status_id, 10) !==
															1
															? ' disabled'
															: '')
													}
												>
													{lc_event.event_id === 0 ? 'ADD' : 'EDIT'}
													<input
														type='file'
														onChange={fileSelect}
														accept='image/*'
														disabled={is_processing}
													/>
												</label>
											</Col>
										</Row>
										<Container className='sp-event-modal-admin-section'>
											<Row>
												<Col
													className={
														'sp-event-modal-field-bottom' +
														(!isAdmin ? ' sp-event-modal-disabled' : '')
													}
												>
													<strong>Admin Only</strong>
												</Col>
											</Row>

											<Row>
												<Col
													xl='8'
													className={
														'sp-event-modal-field-bottom' +
														(!isAdmin ? ' sp-event-modal-disabled' : '')
													}
												>
													Featured event?
												</Col>
												<Col xl='4' className='text-center'>
													<Input
														type='checkbox'
														id='event_modal_admin_featured_image'
														name='event_featured_flag'
														checked={lc_event.event_featured_flag}
														onChange={e => onChangeField(e.target)}
														disabled={
															!isAdmin ||
															parseInt(
																lc_event.event_FK_event_status_id,
																10,
															) !== 2
														}
													/>
												</Col>
											</Row>

											<Row>
												<Col className='sp-event-modal-field-bottom sp-event-modal-featured-img text-center'>
													<img
														src={tmpSelectedFeaturedFile}
														alt='required'
														className='img-fluid'
													/>
													<label
														className={
															'sp-event-file-container btn btn-secondary' +
															(!isAdmin || is_processing ? ' disabled' : '')
														}
													>
														{lc_event.event_id === 0 ? 'ADD' : 'EDIT'} featured
														image
														<input
															type='file'
															onChange={featuredFileSelect}
															accept='image/*'
															disabled={!isAdmin || is_processing}
														/>
													</label>

													{/* <div
														id={
															'event_modal_admin_remove_featured_image_' +
															lc_event.event_id
														}
														className={
															'sp-event-modal-delete-featured-image-icon'
														}
														// onClick={e => eventDeletePost(e, lc_event.event_id)}
													>
														<i className='sp-event-modal-delete-featured-image-icon far fa-trash-alt' />
													</> */}
												</Col>
											</Row>
										</Container>{' '}
									</Col>
								</Row>

								<Row>
									<Col xl={{ size: 3 }} className='sp-event-modal-field-bottom'>
										<Label htmlFor='event_modal_needed_max'>
											Attendee limit
										</Label>
										<Input
											type='text'
											id='event_modal_needed_max'
											placeholder='N/A'
											value={lc_event.event_needed_max}
											name='event_needed_max'
											onChange={e => onChangeField(e.target)}
											required={true}
										/>
									</Col>
									<Col xl={{ size: 3 }} className='sp-event-modal-field-bottom'>
										<Label htmlFor='event_modal_going'>Going to event</Label>
										<Input
											type='text'
											id='event_modal_going'
											placeholder=''
											value={lc_event.going_length}
											name='going_length'
											onChange={e => onChangeField(e.target)}
											readOnly={true}
										/>
									</Col>
									<Col xl={{ size: 4 }} className='sp-event-modal-field-bottom'>
										<Label htmlFor='event_modal_like'>
											Interested in event
										</Label>
										<Input
											type='text'
											id='event_modal_like'
											placeholder=''
											value={lc_event.likes_length}
											name='event_like'
											onChange={e => onChangeField(e.target)}
											readOnly={true}
										/>
									</Col>
									{/* <Col
										xl={{ size: 2 }}
										className='sp-event-modal-field-bottom sp-event-modal-viewed-times'
									>
										<Row>Viewed</Row>
										<Row>0</Row>
										<Row>times</Row>
									</Col>{' '} */}
								</Row>
							</Form>
						</Container>
					)}
				</ModalBody>
			</Modal>

			<ConfirmDialogModal
				isOpen={open_confirm_dialog}
				title={confirm_dialog_title}
				content={confirm_dialog_content}
				fnAction={confirmDelete}
				// className={''}
				btn_ok_label='Confirm'
				btn_cancel_label='Cancel'
				isProcessing={is_processing}
			/>

			<ConfirmDialogModal
				isOpen={open_confirmed_dialog}
				title={confirm_dialog_title}
				content={confirm_dialog_content}
				fnAction={deletedSuccessfully}
				btn_ok_label='none'
				btn_cancel_label='OK'
				isProcessing={is_processing}
			/>

			<Alert
				className='sp-event-modal-alert'
				isOpen={is_alert_open}
				toggle={toggleAlert}
				color={alert_color}
			>
				{alert_message}
			</Alert>

			{/* <ConfirmDialogModal
				isOpen={open_featured_dialog}
				title={confirm_dialog_title}
				content={confirm_dialog_content}
				fnAction={confirmFeatured}
				btn_ok_label='YES'
				btn_cancel_label='NO'
			/> */}
		</>
	)
})

const EventModalEditContainer = React.memo(props => {
	const { handleOpenEventModal } = useContext(SPContext)
	return (
		<EventModalEdit handleOpenEventModal={handleOpenEventModal} {...props} />
	)
})

export default EventModalEditContainer
